import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import Button from '@material-ui/core/Button';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Link } from "react-router-dom";
import { Icon } from 'semantic-ui-react'
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import Payment from '@material-ui/icons/AccountBalance';
import ControlPoint from '@material-ui/icons/ControlPoint';
import AccountBalance from '@material-ui/icons/Payment';
import Add from '@material-ui/icons/Add';
import Home from '@material-ui/icons/Home';
import PermIdentity from '@material-ui/icons/PermIdentity';
import WorkIcon from '@material-ui/icons/Work';
import ShoppingBasket from '@material-ui/icons/ShoppingBasket';
import Shop from '@material-ui/icons/Shop';
import LocalOffer from '@material-ui/icons/LocalOffer';
import CreditCard from '@material-ui/icons/CreditCard';
import ShoppingCart from '@material-ui/icons/ShoppingCart';
import Input from '@material-ui/icons/Input';
import BarChart from '@material-ui/icons/BarChart';
import LibraryBooks from '@material-ui/icons/LibraryBooks';
import Assessment from '@material-ui/icons/Assessment';
import AccountCircle from '@material-ui/icons/AccountCircle';
import Price from '@material-ui/icons/AttachMoney';
import Info from '@material-ui/icons/Info';
import Timeline from '@material-ui/icons/Timeline';
import Settings from '@material-ui/icons/Settings';
import PlaylistAddCheck from '@material-ui/icons/PlaylistAddCheck';
import SupervisedUserCircle from '@material-ui/icons/SupervisedUserCircle';
import Build from '@material-ui/icons/Build';
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';
import ChromeReaderMode from '@material-ui/icons/ChromeReaderMode';
import AssignmentInd from '@material-ui/icons/AssignmentInd';
import ImportContacts from '@material-ui/icons/ImportContacts';
import MenuIcon from '@material-ui/icons/Menu';
import AccountBox from '@material-ui/icons/AccountBox';
import Accessibility from '@material-ui/icons/Accessibility';
import DirectionsBus from '@material-ui/icons/DirectionsBus';
import ListAlt from '@material-ui/icons/ListAlt';
import MailOutline from '@material-ui/icons/MailOutline';
import MoneyIcon from '@material-ui/icons/Money';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ReadCookie from '../../functions/readcookies';
import ReceiptIcon from '@material-ui/icons/Receipt';
import ShopIcon from '@material-ui/icons/Shop';
import IconButton from '@material-ui/core/IconButton';
import NotificationsIcon from '@material-ui/icons/Notifications';
import PostAddIcon from '@material-ui/icons/Class';
import Release from '../../functions/release';

const useStyles = {
  list: {
    width: 250
  },
  fullList: {
    width: 'auto',
  },
};

const drawerWidth = 200;

const styles = theme => ({
  root: {
    display: 'flex',
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
  },
  drawerHeader: {
    display: 'flex',
    alignItems: 'center',
    padding: '0 8px',
    ...theme.mixins.toolbar,
    justifyContent: 'flex-end',
  },
  content: {
    flexGrow: 1,

    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: -drawerWidth,
  },
  contentShift: {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
  },
});

class TemporaryDrawer extends React.Component {

  componentDidMount() {
    this.menuView();
  }

  classes = useStyles;

  state = {  };



  closeAdminControl = () => {
    if (this.state.adminControl) {
      this.setState({ adminControl: false })
      localStorage.setItem('adminControl', false);
    }
    else {
      this.setState({ 
        salesMenu: false, 
        purchaseAndStockMenu: false,  
        accountingmenu: false,
        Service: false, 
        machineMenu: false, 
        webMaster: false, 
        appMaster: false, 
        adminControl: true,
      });
      localStorage.setItem('salesMenu', false);
      localStorage.setItem('Service', false);
      localStorage.setItem('purchaseAndStockMenu', false);
      localStorage.setItem('accountingmenu', false);
      localStorage.setItem('machineMenu', false);
      localStorage.setItem('webMaster', false);
      localStorage.setItem('appMaster', false);
      localStorage.setItem('adminControl', true);
    }
  }

  closeAppMaster = () => {
    if (this.state.appMaster) {
      this.setState({ appMaster: false })
      localStorage.setItem('appMaster', false);
    }
    else {
      this.setState({ 
        salesMenu: false, 
        Service: false,
        purchaseAndStockMenu: false,  
        accountingmenu: false, 
        machineMenu: false, 
        webMaster: false, 
        appMaster: true, 
        adminControl: false
      });
      localStorage.setItem('salesMenu', false);
      localStorage.setItem('Service', false);
      localStorage.setItem('purchaseAndStockMenu', false);
      localStorage.setItem('accountingmenu', false);
      localStorage.setItem('machineMenu', false);
      localStorage.setItem('webMaster', false);
      localStorage.setItem('appMaster', true);
      localStorage.setItem('adminControl', false);
    }
  }


  closeWebMaster = () => {
    if (this.state.webMaster) {
      this.setState({ webMaster: false })
      localStorage.setItem('webMaster', false);
    }
    else {
      this.setState({ 
        salesMenu: false, 
        Service: false,
        purchaseAndStockMenu: false,  
        accountingmenu: false, 
        machineMenu: false, 
        webMaster: true, 
        appMaster: false, 
        adminControl: false
      });
      localStorage.setItem('salesMenu', false);
      localStorage.setItem('Service', false);
      localStorage.setItem('purchaseAndStockMenu', false);
      localStorage.setItem('accountingmenu', false);
      localStorage.setItem('machineMenu', false);
      localStorage.setItem('webMaster', true);
      localStorage.setItem('appMaster', false);
      localStorage.setItem('adminControl', false);
    }
  }


  closeMachineMenu = () => {
    if (this.state.machineMenu) {
      this.setState({ machineMenu: false })
      localStorage.setItem('machineMenu', false);
    }
    else {
      this.setState({ 
        salesMenu: false, 
        Service: false,
        purchaseAndStockMenu: false,  
        accountingmenu: false, 
        machineMenu: true, 
        webMaster: false, 
        appMaster: false, 
        adminControl: false
      });
      localStorage.setItem('salesMenu', false);
      localStorage.setItem('Service', false);
      localStorage.setItem('purchaseAndStockMenu', false);
      localStorage.setItem('accountingmenu', false);
      localStorage.setItem('machineMenu', true);
      localStorage.setItem('webMaster', false);
      localStorage.setItem('appMaster', false);
      localStorage.setItem('adminControl', false);
    }
  }

  closeAccountingMenu = () => {
    if (this.state.accountingmenu) {
      this.setState({ accountingmenu: false })
      localStorage.setItem('accountingmenu', false);
    }
    else {
      this.setState({ 
        salesMenu: false, 
        Service: false,
        purchaseAndStockMenu: false,  
        accountingmenu: true, 
        machineMenu: false, 
        webMaster: false, 
        appMaster: false, 
        adminControl: false
      });
      localStorage.setItem('salesMenu', false);
      localStorage.setItem('Service', false);
      localStorage.setItem('purchaseAndStockMenu', false);
      localStorage.setItem('accountingmenu', true);
      localStorage.setItem('machineMenu', false);
      localStorage.setItem('webMaster', false);
      localStorage.setItem('appMaster', false);
      localStorage.setItem('adminControl', false);
    }
  }


  closepurchaseAndStockMenu = () => {
    if (this.state.purchaseAndStockMenu) {
      this.setState({ purchaseAndStockMenu: false })
      localStorage.setItem('purchaseAndStockMenu', false);
    }
    else {
      this.setState({ 
        salesMenu: false, 
        Service: false,
        purchaseAndStockMenu: true,  
        accountingmenu: false, 
        machineMenu: false, 
        webMaster: false, 
        appMaster: false, 
        adminControl: false
      });
      localStorage.setItem('salesMenu', false);
      localStorage.setItem('Service', false);
      localStorage.setItem('purchaseAndStockMenu', true);
      localStorage.setItem('accountingmenu', false);
      localStorage.setItem('machineMenu', false);
      localStorage.setItem('webMaster', false);
      localStorage.setItem('appMaster', false);
      localStorage.setItem('adminControl', false);
    }
  } 


  closeServiceMenu = () => {
    if (this.state.Service) {
      this.setState({ Service: false })
      localStorage.setItem('Service', false);
    }
    else {
      this.setState({ 
        salesMenu: false, 
        Service: true,
        purchaseAndStockMenu: false,  
        accountingmenu: false, 
        machineMenu: false, 
        webMaster: false,
        appMaster: false, 
        adminControl: false
      });
      localStorage.setItem('salesMenu', false);
      localStorage.setItem('Service', true);
      localStorage.setItem('purchaseAndStockMenu', false);
      localStorage.setItem('accountingmenu', false);
      localStorage.setItem('machineMenu', false);
      localStorage.setItem('webMaster', false);
      localStorage.setItem('appMaster', false);
      localStorage.setItem('adminControl', false);
    }
  }
  
  closeSalesMenu = () => {
    if (this.state.salesMenu) {
      this.setState({ salesMenu: false })
      localStorage.setItem('salesMenu', false);
    }
    else {
      this.setState({ 
        salesMenu: true, 
        Service: false,
        purchaseAndStockMenu: false,  
        accountingmenu: false, 
        machineMenu: false, 
        webMaster: false, 
        appMaster: false, 
        adminControl: false
      });
      localStorage.setItem('salesMenu', true);
      localStorage.setItem('Service', false);
      localStorage.setItem('purchaseAndStockMenu', false);
      localStorage.setItem('accountingmenu', false);
      localStorage.setItem('machineMenu', false);
      localStorage.setItem('webMaster', false);
      localStorage.setItem('appMaster', false);
      localStorage.setItem('adminControl', false);
    }
  } 

  menuView() {

    let salesMenu = localStorage.getItem('salesMenu');
    let purchaseAndStockMenu = localStorage.getItem('purchaseAndStockMenu');
    let accountingmenu = localStorage.getItem('accountingmenu');
    let machineMenu = localStorage.getItem('machineMenu');
    let webMaster = localStorage.getItem('webMaster');
    let appMaster = localStorage.getItem('appMaster');
    let adminControl = localStorage.getItem('adminControl');
    let Service = localStorage.getItem('Service');

    if (salesMenu == 'false') { salesMenu = false; }
    else { salesMenu = true; }
    if (Service == 'false') { Service = false; }
    else { Service = true; }
    if (purchaseAndStockMenu == 'false') { purchaseAndStockMenu = false; }
    else { purchaseAndStockMenu = true; }
    if (accountingmenu == 'false') { accountingmenu = false; }
    else { accountingmenu = true; }
    if (machineMenu == 'false') { machineMenu = false; }
    else { machineMenu = true; }
    if (webMaster == 'false') { webMaster = false; }
    else { webMaster = true; }
    if (appMaster == 'false') { appMaster = false; }
    else { appMaster = true; }
    if (adminControl == 'false') { adminControl = false; }
    else { adminControl = true; }

    

    this.setState({ salesMenu, purchaseAndStockMenu, accountingmenu, Service, machineMenu, webMaster, appMaster, adminControl })
  }

  toggleDrawer = (side, open) => event => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    this.setState({ ...this.state, [side]: open });
  };


  sideList = side => {
    let data = localStorage.getItem('menus');;
    try {
      data = JSON.parse(data);
    } catch (error) {
      data = [];
    }
    let salesMenu = [
      { menu: 'place-order', menuName: 'Place Order', icon: (<ShoppingBasket />) },
      { menu: 'customer-order', menuName: 'Customer Order', icon: (<ShopIcon />) },
      { menu: 'quotation', menuName: 'Quotation', icon: (<ChromeReaderMode />) },
      { menu: 'invoice', menuName: 'Invoice', icon: (<LibraryBooks />) },
      { menu: 'credit-note', menuName: 'Credit Note', icon: (<ShoppingCart />) },
      { menu: 'stock-transfer', menuName: 'Stock Transfer', icon: (<DirectionsBus />) },
      { menu: 'sales-report', menuName: 'Sales Report', icon: (<ImportContacts />) },
      { menu: 'customer-statement', menuName: 'Customer Statement', icon: (<Assessment />) },
     ];

     let ServiceMenu = [
      { menu: 'job-card', menuName: 'Service', icon: (<WorkIcon />) },
      { menu: 'job-card-report', menuName: 'JobCard Report', icon: (<LibraryBooks />) },
      { menu: 'service-history', menuName: 'Service History', icon: (<Assessment />) },
      { menu: 'service-type', menuName: 'Service Type', icon: (<ListAlt />) },
      { menu: 'labor', menuName: 'Mechanic', icon: (<SupervisorAccountIcon />) },
     ];

     let purchaseAndStockMenu = [
      { menu: 'purchase-request', menuName: 'Purchase Request', icon: (<Input />) },
      { menu: 'purchase-details', menuName: 'Purchase Details', icon: (<ShoppingCart />) },
      { menu: 'stock-level', menuName: 'Stock Level', icon: (<Home />) },
      { menu: 'debit-notes', menuName: 'Debot Notes', icon: (<Home />) },
      { menu: 'stock-info', menuName: 'Stock Info', icon: (<Info />) },
      { menu: 'analytics', menuName: 'Analytics', icon: (<Timeline />) },
      { menu: 'stock-audit', menuName: 'Stock Audit', icon: (<BarChart />) },
      { menu: 'purchaser-statement', menuName: 'Purchaser Statement', icon: (<Assessment />) },
    ];

    let accountingMenu = [
      { menu: 'receipt', menuName: 'Receipt', icon: (<ListAlt />) },
      { menu: 'payment', menuName: 'Payment', icon: (<ListAlt />) },
      { menu: 'expense', menuName: 'Expense', icon: (<PlaylistAddCheck />) },
      { menu: 'chitta', menuName: 'Chitta', icon: (<PlaylistAddCheck />) },
      { menu: 'journal', menuName: 'Journal', icon: (<MoneyIcon />) },
      { menu: 'expense-report', menuName: 'Income And Expense Report', icon: (<ReceiptIcon />) },
      { menu: 'hsncode-report', menuName: 'HSNCode Report', icon: (<ReceiptIcon />) },
      { menu: 'gst-sales-report', menuName: 'GST Sales Report', icon: (<ReceiptIcon />) },
      { menu: 'gst-purchase-report', menuName: 'GST Purchase Report', icon: (<ReceiptIcon />) },
      
    ];

    let appControlMenu = [
      { menu: 'executive-control', menuName: 'Executive Control', icon: (<Accessibility />) },
      { menu: 'executive-app-branch-mapping', menuName: 'Executive App Branch Mapping', icon: (<AccountCircle />) },
      { menu: 'app-payment-mode-mapping', menuName: 'App Payment Mode Mapping', icon: (<AccountBox />), type: 'appControlMenu' },
      { menu: 'edit-bank-details', menuName: 'Edit Bank Detail', icon: (<AccountBalance />)},
      { menu: 'edit-upi-details', menuName: 'Edit UPI Details', icon: (<Payment />)},
      { menu: 'offers-scroll', menuName: 'Offers Scroll', icon: (<LocalOffer />)},
    ];

    let adminControl = [
      { menu: 'executive', menuName: 'Executive', icon: (<SupervisorAccountIcon />) },
      { menu: 'add-menu', menuName: 'Add Menu', icon: (<Add />) },
      { menu: 'brand-control', menuName: 'Brand Control', icon: (<PostAddIcon />) },
      { menu: 'customer-type', menuName: 'Customer Type', icon: (<Icon style={{fontSize: '16px'}} name='tag' />) },
      { menu: 'customer-type-mapping', menuName: 'Customer Type Mapping', icon: (<Icon style={{fontSize: '16px'}} name='sitemap' />) },
      { menu: 'point-settings', menuName: 'Point settings', icon: (<ControlPoint />) },
      { menu: 'notification', menuName: 'Notification', icon: (<NotificationsIcon />) },
      { menu: 'statement-mapping', menuName: 'Statement Mapping', icon: (<PlaylistAddCheck />) },
      { menu: 'web-access', menuName: 'Web Access', icon: (<Settings />) },
    ];

    let masterMenu = [
      { menu: 'add-parts', menuName: 'Add Parts', icon: (<Build />) },
      { menu: 'add-customer', menuName: 'Add Customer', icon: (<SupervisedUserCircle />) },
      { menu: 'add-purchaser', menuName: 'Add Purchaser', icon: (<AssignmentInd />) },
      { menu: 'combo', menuName: 'Combo', icon: (<AssignmentInd />) },
      { menu: 'expense-master', menuName: 'Expense Master', icon: (<PlaylistAddCheck />) },
      { menu: 'executive-web-branch-mapping', menuName: 'Executive Web Branch Mapping', icon: (<AccountCircle />) },
      { menu: 'web-payment-mode-mapping', menuName: 'Web Payment Mode Mapping', icon: (<AccountBox />) },
      { menu: 'discount-menu', menuName: 'Discount Menu', icon: (<Price />) },
      { menu: 'sms', menuName: 'SMS', icon: (<MailOutline />) },
    ];

    let machineMenu = [
      { menu: 'machine', menuName: 'Machine', icon: (<PlaylistAddCheck />) },
      { menu: 'machine-model', menuName: 'Machine Model', icon: (<Info />) },
      { menu: 'machine-customer', menuName: 'Machine Customer', icon: (<PermIdentity />) },
      { menu: 'enquiry-customer', menuName: 'Enquiry Customer', icon: (<PermIdentity />) },
      { menu: 'machine-quotation', menuName: 'Machine Quotation', icon: (<ChromeReaderMode />) },
      { menu: 'machine-invoice', menuName: 'Mahine Invoice', icon: (<LibraryBooks />) },
      { menu: 'machine-receipt', menuName: 'Receipt', icon: (<ListAlt />) },
      { menu: 'machine-payment', menuName: 'Payment', icon: (<ListAlt />) },
      { menu: 'machine-customer-statement', menuName: 'Statement', icon: (<Assessment />) },
      
    ];

    
    return (
      <div className={this.classes.list} role="presentation"
        onKeyDown={this.toggleDrawer(side, false)} >
        <List>

          <ExpansionPanel style={{width: '100%'}} expanded={this.state.salesMenu}>
            <ExpansionPanelSummary onClick={this.closeSalesMenu} expandIcon={<ExpandMoreIcon />}>
              <ListItemText><b>Sales</b></ListItemText>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              <List style={{width: '100%'}}>
                {
                  salesMenu.map((c) => {
                  return (
                    <div>
                      {
                        data.map((cc) => {
                          if (c.menu == cc.menu) {
                            return (
                              <Link to={"/"+Release()+"/"+c.menu}>
                                <ListItem style={{width: '100%'}} button key={c.menuName}>
                                  <ListItemIcon>{c.icon}</ListItemIcon>
                                  <ListItemText primary={c.menuName} />
                                </ListItem>
                              </Link>
                            )
                          }
                        })
                      }
                    </div>
                  )
                })
                }
              </List>
            </ExpansionPanelDetails>
          </ExpansionPanel>

          <ExpansionPanel style={{width: '100%'}} expanded={this.state.Service}>
            <ExpansionPanelSummary onClick={this.closeServiceMenu} expandIcon={<ExpandMoreIcon />}>
              <ListItemText><b>Service</b></ListItemText>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              <List style={{width: '100%'}}>
                {
                  ServiceMenu.map((c) => {
                  return (
                    <div>
                      {
                        data.map((cc) => {
                          if (c.menu == cc.menu) {
                            return (
                              <Link to={"/"+Release()+"/"+c.menu}>
                                <ListItem  style={{width: '100%'}} button key={c.menuName}>
                                  <ListItemIcon>{c.icon}</ListItemIcon>
                                  <ListItemText primary={c.menuName} />
                                </ListItem>
                              </Link>
                            )
                          }
                        })
                      }
                    </div>
                  )
                })
                }
              </List>
            </ExpansionPanelDetails>
          </ExpansionPanel>

          
          <ExpansionPanel style={{width: '100%'}} expanded={this.state.purchaseAndStockMenu}>
            <ExpansionPanelSummary onClick={this.closepurchaseAndStockMenu} expandIcon={<ExpandMoreIcon />}>
              <ListItemText><b>Purchase & Stock</b></ListItemText>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              <List  style={{width: '100%'}}>
                {
                  purchaseAndStockMenu.map((c) => {
                  return (
                    <div>
                      {
                        data.map((cc) => {
                          if (c.menu == cc.menu) {
                            return (
                              <Link to={"/"+Release()+"/"+c.menu}>
                                <ListItem  style={{width: '100%'}} button key={c.menuName}>
                                  <ListItemIcon>{c.icon}</ListItemIcon>
                                  <ListItemText primary={c.menuName} />
                                </ListItem>
                              </Link>
                            )
                          }
                        })
                      }
                    </div>
                  )
                })
                }
              </List>
            </ExpansionPanelDetails>
          </ExpansionPanel>

          
          <ExpansionPanel style={{width: '100%'}} expanded={this.state.accountingmenu}>
            <ExpansionPanelSummary onClick={this.closeAccountingMenu} expandIcon={<ExpandMoreIcon />}>
              <ListItemText><b>Accounting</b></ListItemText>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              <List  style={{width: '100%'}}>
              {
                  accountingMenu.map((c) => {
                  return (
                    <div>
                      {
                        data.map((cc) => {
                          if (c.menu == cc.menu) {
                            return (
                              <Link to={"/"+Release()+"/"+c.menu}>
                                <ListItem  style={{width: '100%'}} button key={c.menuName}>
                                  <ListItemIcon>{c.icon}</ListItemIcon>
                                  <ListItemText primary={c.menuName} />
                                </ListItem>
                              </Link>
                            )
                          }
                        })
                      }
                    </div>
                  )
                })
                }
              </List>
            </ExpansionPanelDetails>
          </ExpansionPanel>





          
          <ExpansionPanel style={{width: '100%'}} expanded={this.state.machineMenu}>
            <ExpansionPanelSummary onClick={this.closeMachineMenu} expandIcon={<ExpandMoreIcon />}>
              <ListItemText><b>Machine</b></ListItemText>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              <List style={{width: '100%'}}>
                {
                  machineMenu.map((c) => {
                  return (
                    <div>
                      {
                        data.map((cc) => {
                          if (c.menu == cc.menu && c.menu != 'machinesales') {
                            return (
                              <Link to={"/"+Release()+"/"+c.menu}>
                                <ListItem style={{width: '100%'}} button key={c.menuName}>
                                  <ListItemIcon>{c.icon}</ListItemIcon>
                                  <ListItemText primary={c.menuName} />
                                </ListItem>
                              </Link>
                            )
                          }
                          else if (c.menu == cc.menu && c.menu == 'machinesales') {
                            return (
                              <div>
                                <Link to={"/"+Release()+"/machine/quotation"} id='machinesales'>
                                  <ListItem style={{width: '100%'}} button key='Machine Quotation' onClick={ () => { this.setState({ type: 'Quotation'}) }}>
                                      <ListItemIcon><ChromeReaderMode /></ListItemIcon>
                                      <ListItemText primary='Quotation'/>
                                  </ListItem>
                                </Link>
                                <Link to={"/"+Release()+"/machine/invoice"} id='machinesales'>
                                  <ListItem style={{width: '100%'}} button key='Machine Invoice' onClick={ () => { this.setState({ type: 'Invoice'}) }}>
                                      <ListItemIcon><LibraryBooks /></ListItemIcon>
                                      <ListItemText primary='Invoice' />
                                  </ListItem>
                                </Link>
                              </div>
                            )
                          }
                        })
                      }
                    </div>
                  )
                })
                }

              </List>
            </ExpansionPanelDetails>
          </ExpansionPanel>

          
          

          <ExpansionPanel style={{width: '100%'}} expanded={this.state.webMaster}>
            <ExpansionPanelSummary onClick={this.closeWebMaster} expandIcon={<ExpandMoreIcon />}>
              <ListItemText><b>WEB Master</b></ListItemText>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              <List style={{width: '100%'}}>
                {
                  masterMenu.map((c) => {
                  return (
                    <div>
                      {
                        data.map((cc) => {
                          if (c.menu == cc.menu) {
                            return (
                              <Link to={"/"+Release()+"/"+c.menu}>
                                <ListItem style={{width: '100%'}} button key={c.menuName}>
                                  <ListItemIcon>{c.icon}</ListItemIcon>
                                  <ListItemText primary={c.menuName} />
                                </ListItem>
                              </Link>
                            )
                          }
                        })
                      }
                    </div>
                  )
                })
                }
              </List>
            </ExpansionPanelDetails>
          </ExpansionPanel>

           

          <ExpansionPanel style={{width: '100%'}} expanded={this.state.appMaster}>
            <ExpansionPanelSummary onClick={this.closeAppMaster} expandIcon={<ExpandMoreIcon />}>
              <ListItemText><b>APP Master</b></ListItemText>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              <List style={{width: '100%'}}>
                {
                  appControlMenu.map((c) => {
                    return (
                      <div>
                        {
                          data.map((cc) => {
                            if (c.menu == cc.menu) {
                              return (
                                <Link to={"/"+Release()+"/"+c.menu}>
                                  <ListItem style={{width: '100%'}} button key={c.menuName}>
                                    <ListItemIcon>{c.icon}</ListItemIcon>
                                    <ListItemText primary={c.menuName} />
                                  </ListItem>
                                </Link>
                              )
                            }
                          })
                        }
                      </div>
                    )
                  })
                }
              </List>
            </ExpansionPanelDetails>
          </ExpansionPanel>

          

          <ExpansionPanel style={{width: '100%'}} expanded={this.state.adminControl}>
            <ExpansionPanelSummary onClick={this.closeAdminControl} expandIcon={<ExpandMoreIcon />}>
              <ListItemText><b>Admin Control</b></ListItemText>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              <List style={{width: '100%'}}>
                {
                  adminControl.map((c) => {
                  return (
                    <div>
                      {
                        data.map((cc) => {
                          
                          if (c.menu == cc.menu) {
                            return (
                              <Link to={"/"+Release()+"/"+c.menu}>
                                <ListItem style={{width: '100%'}} button key={c.menuName}>
                                  <ListItemIcon>{c.icon}</ListItemIcon>
                                  <ListItemText primary={c.menuName} />
                                </ListItem>
                              </Link>
                            )
                          }
                        })
                      }
                    </div>
                  )
                })
                }
              </List>
            </ExpansionPanelDetails>
          </ExpansionPanel>

          <Link to={"/"+Release()+"/tickets"}>
            <ExpansionPanel style={{width: '100%'}} >
              <ExpansionPanelSummary>
                <ListItemText style={{width: '100%'}} primary='Tickets' />
              </ExpansionPanelSummary>
            </ExpansionPanel>
          </Link>

        </List>
      </div>
    )
  }

  render() {
    const { classes, theme } = this.props;
    return (
      <div>
        <IconButton onClick={this.toggleDrawer('left', true)}
          edge="start" color="inherit" aria-label="Menu">
          <MenuIcon />
        </IconButton>
        <Drawer open={this.state.left} onClose={this.toggleDrawer('left', false)}>
          <div className={classes.drawerHeader}>
            <center style={{marginLeft: 'auto', marginRight: 'auto', marginBottom: 'auto', marginTop: 'auto' }}>
              <Link to={"/"+Release()+"/dashboard"} id='dashboard'>
                <h1>VAIGAI CLAAS</h1>
              </Link>
            </center>
          </div>
          {this.sideList('left')}
        </Drawer>
      </div>
    );
  }

  


}

TemporaryDrawer.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(TemporaryDrawer);
